document.addEventListener('DOMContentLoaded', function () {
  document.querySelectorAll('[data-cinematic-hero]').forEach(section => {

    const track = section.querySelector('[data-track]');
    if (!track) return;

    const slides = Array.from(track.children);
    const nextBtn = section.querySelector('.next');
    const prevBtn = section.querySelector('.prev');

    let index = 0;

    const CLICK_THRESHOLD = 10;

    // -------------------------
    // 🎬 RENDER FUNCTION
    // -------------------------
    function update() {
      track.style.transition = 'transform 0.6s ease';
      track.style.transform = `translateX(-${index * 100}%)`;

      // 🌫 parallax background effect
      slides.forEach((slide, i) => {
        const bg = slide.querySelector('.cinematic-hero__bg');
        if (!bg) return;

        const offset = i - index;

        const parallaxX = offset * 40;
        const scale = i === index ? 1.05 : 1.65;

        bg.style.transform = `scale(${scale}) translateX(${parallaxX}px)`;
      });
    }

    // -------------------------
    // 🎮 NAVIGATION
    // -------------------------
    function goNext() {
      index = (index + 1) % slides.length;
      update();
    }

    function goPrev() {
      index = (index - 1 + slides.length) % slides.length;
      update();
    }

    nextBtn?.addEventListener('click', goNext);
    prevBtn?.addEventListener('click', goPrev);

    // -------------------------
    // 🖱 SLIDE TAP HANDLING
    // -------------------------
    slides.forEach(slide => {
      let pointerDownX = 0;
      let isMoving = false;

      slide.addEventListener('pointerdown', (e) => {
        pointerDownX = e.clientX;
        isMoving = false;
      });

      slide.addEventListener('pointermove', (e) => {
        if (Math.abs(e.clientX - pointerDownX) > CLICK_THRESHOLD) {
          isMoving = true;
        }
      });

      slide.addEventListener('pointerup', () => {
        if (isMoving) return;

        if (event.target.closest('a, button, input, textarea, select')) return;

        const link = slide.dataset.slideLink;

        if (link) {
          window.location.href = link;
        }
      });
    });

    // -------------------------
    // 🚀 INIT
    // -------------------------
    update();

  });
});